import * as React from 'react';
import { forwardRef } from 'react';
const Check = (props, ref) => {
    return (React.createElement("svg", { viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props },
        React.createElement("path", { d: "M10.72 4.45a.937.937 0 0 1 1.262-.33c.442.25.594.8.338 1.231L8.65 11.55a.937.937 0 0 1-1.262.33.888.888 0 0 1-.338-1.231l3.67-6.199Z", fill: "var(--mollie-ui-icon-fill, currentColor)" }),
        React.createElement("path", { d: "M3.826 8.425a.885.885 0 0 1 0-1.273.94.94 0 0 1 1.306 0l3.33 3.267c.36.352.36.922 0 1.274a.94.94 0 0 1-1.307 0L3.826 8.425Z", fill: "var(--mollie-ui-icon-fill, currentColor)" })));
};
const ForwardRef = forwardRef(Check);
export default ForwardRef;
ForwardRef.displayName = 'Check';
//# sourceMappingURL=Check.js.map